import styled from 'styled-components/macro';

export const Header = styled.header`
  position: fixed;
  top: 0;
  z-index: ${({ theme }) => theme.zIndex.zIndex4};

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: 4rem;
  padding: ${({ theme }) => `0 ${theme.spacing.zero_1} 0 ${theme.spacing.zero_1}`};
  border-bottom: 1px solid ${({ theme }) => theme.colors.black_10};

  background-color: ${({ theme }) => theme.colors.white};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    height: 3.5rem;
  }
`;

export const Logo = styled.div`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 1.25rem 0;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: safe center;
  padding: 6rem 0 0 0;
  height: calc(100vh - 6rem);
`;
